import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import WelcomePage from './components/WelcomePage';
import UserTypeSelectionPage from './components/UserTypeSelectionPage';
import SignupForm from './components/SignupForm';
import LoginForm from './components/LoginForm';
import VerificationForm from './components/VerificationForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import DashboardPage from './components/DashboardPage';
import SecuritySettings from './components/SecuritySettings';
import ProfileCompletionForm from './components/ProfileCompletionForm';
import SubscriptionPage from './components/SubscriptionPage/SubscriptionPage';
import ReturnHandler from './components/ReturnHandler/ReturnHandler';
import OtpViewPage from './components/OtpViewPage';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import AdminLoginPage from './components/AdminLoginPage/AdminLoginPage';
import AdminRegisterPage from './components/AdminRegisterPage/AdminRegisterPage';
import { UploadProvider } from './context/UploadContext';
import UploadProgressBanner from './components/UploadProgressBanner';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <UploadProvider>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/select-account-type" element={<UserTypeSelectionPage />} />
          <Route path="/signup" element={<SignupForm />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/verify" element={<VerificationForm />} />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />
          <Route path="/complete-profile" element={<ProfileCompletionForm />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/security" element={<SecuritySettings />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/subscription-return" element={<ReturnHandler />} />
          <Route path="/otp/:token" element={<OtpViewPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin-login" element={<AdminLoginPage />} />
          <Route path="/admin-register" element={<AdminRegisterPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <UploadProgressBanner />
      </UploadProvider>
    </Router>
  );
};

export default App;
